import 'vuetify/lib/styles/main.sass'

// Vuetify
import {createVuetify} from 'vuetify'
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {fr} from 'vuetify/locale'

import {aliases, md} from 'vuetify/iconsets/md'
import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'md',
        aliases,
        sets: {
            md,
        },
    },
    locale: {
        locale: 'fr',
        fallback: 'en',
        messages: {fr}
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                dark: false,
                variables: {},
                colors: {
                    primary: '#1B5E20',
                    secondary: '#BF360C',
                    accent: '#389a24',
                    grey: '#757575',
                    blackish: '#272727',
                }
            }
        }
    }
})

